import { ProviderType } from "@redotech/redo-model/integration/integration-schema-definition";
import type { infer as zInfer } from "zod/v4";
import { array, object, string, enum as zEnum } from "zod/v4";

export const getGlobalEIntegration = {
  name: "getGlobalEIntegration" as const,
  input: object({}),
  output: object({
    globalEIntegration: object({
      username: string().nullish(),
      apiDomain: string(),
      provides: array(
        zEnum([ProviderType.Refund, ProviderType.Shipping]),
      ).optional(),
    }).optional(),
  }),
};

export type GlobalEIntegration = zInfer<typeof getGlobalEIntegration.output>;
